<template>
  <v-container id="user-profile" fluid tag="section">
    <!-- Floating Background Shapes -->
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>

    <v-row justify="center" align="center" class="">
      <v-col cols="12">
        <v-card class="login-main-card" elevation="24" rounded="xl">
          <!-- Header Section -->
          <div class="login-header-section">
            <!-- Logo Section -->
            <div class="logo-section text-center">
              <div class="logo-background mx-auto">
                <lord-icon
                  src="https://cdn.lordicon.com/vvyxyrur.json"
                  trigger="loop"
                  state="loop-cycle"
                  style="width:80px;height:80px"
                  class="logo-image"
                ></lord-icon>
              </div>
              <div class="login-message mt-4">
                <h1 class="login-title">ผู้ดูแลระบบ</h1>
                <p class="login-subtitle mb-0"> หน่วยงาน</p>
              </div>
            </div>

            <!-- Login Instructions -->
            <div class="login-instructions mt-6">
              <v-row>
                <v-col cols="12" sm="6" class="text-center">
                  <v-chip
                    class="glass-chip ma-1"
                    color="error"
                    text-color="white"
                    small
                  >
                    <v-icon left small>mdi-account</v-icon>
                    Username: รหัสหน่วยงาน
                  </v-chip>
                </v-col>
                <v-col cols="12" sm="6" class="text-center">
                  <v-chip
                    class="glass-chip ma-1"
                    color="error darken-2"
                    text-color="white"
                    small
                  >
                    <v-icon left small>mdi-lock</v-icon>
                    Password: ตามที่กำหนด
                  </v-chip>
                </v-col>
              </v-row>
              <div class="text-center mt-2">
                <v-chip class="glass-chip-example" color="orange" outlined small>
                  ระบบจัดการหน่วยงาน
                </v-chip>
              </div>
            </div>
          </div>

          <v-card-text class="pa-8">
            <!-- Login Button -->
            <div class="text-center login-button-section">
              <v-dialog v-model="dialogLogin" persistent max-width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    class="login-btn" 
                    x-large
                    rounded
                    elevation="8"
                    v-bind="attrs" 
                    v-on="on"
                    block
                  >
                    <v-icon left size="28">mdi-login-variant</v-icon>
                    เข้าสู่ระบบ
                    <v-icon right size="28">mdi-shield-account</v-icon>
                  </v-btn>
                </template>

                <!-- Login Dialog -->
                <v-card class="login-dialog" rounded="xl">
                  <!-- Dialog Header -->
                  <v-card-title class="dialog-header white--text">
                    <div class="dialog-title-content">
                      <div class="dialog-icon-bg">
                        <v-icon size="32" color="white">mdi-shield-account</v-icon>
                      </div>
                      <div class="ml-4">
                        <h3 class="mb-1">ผู้ดูแลระบบ</h3>
                        <p class="subtitle mb-0">หน่วยงาน</p>
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-text class="pa-6">
                    <v-form ref="form" lazy-validation>
                      <v-text-field
                        color="error"
                        prepend-icon="mdi-account"
                        name="login"
                        label="ชื่อผู้ใช้งาน (รหัสหน่วยงาน)"
                        type="text"
                        v-model="user_name"
                        :rules="[v => !!v || 'กรุณากรอกชื่อผู้ใช้งาน']"
                        rounded
                        outlined
                        class="enhanced-input mb-4"
                      ></v-text-field>
                      
                      <v-text-field
                        color="error"
                        name="password"
                        label="รหัสผ่าน"
                        prepend-icon="mdi-lock-outline"
                        id="password"
                        v-model="user_password"
                        rounded
                        :rules="[v => !!v || 'กรุณากรอกรหัสผ่าน']"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        @click:append="show1 = !show1"
                        outlined
                        class="enhanced-input"
                        hint="ตามที่ส่วนกลางกำหนด"
                        persistent-hint
                      ></v-text-field>
                    </v-form>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="pa-4">
                    <v-btn
                      rounded
                      outlined
                      color="grey"
                      @click="dialogLogin = false"
                      class="cancel-btn"
                    >
                      <v-icon left>mdi-close</v-icon>
                      ยกเลิก
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      rounded
                      large
                      @click="userLogin()"
                      class="submit-btn"
                      elevation="4"
                      :loading="loading"
                    >
                      <v-icon left>mdi-login-variant</v-icon> 
                      เข้าสู่ระบบ
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

    
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar for notifications -->
    <v-snackbar v-model="dialog" top class="enhanced-snackbar" :timeout="snackbar_timeout">
      <div class="white--text">
        <v-icon color="white" left>mdi-information</v-icon>
        {{ dialog_msg }}
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="dialog = false" color="white">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      ApiKey: 'HRvec2021',
      show1: false,
      dialogLogin: false,
      data_syslog: {},
      user_name: "",
      user_password: "",
      dialog: false,
      dialog_msg: "",
      loading: false,
      snackbar_timeout: 10000,
    };
  },
  mounted() {
    // Add entrance animation classes
    this.$nextTick(() => {
      const mainCard = document.querySelector('.login-main-card');
      const logoSection = document.querySelector('.logo-section');
      const instructions = document.querySelector('.login-instructions');
      const buttonSection = document.querySelector('.login-button-section');
      const quickStats = document.querySelector('.quick-stats');

      if (mainCard) mainCard.classList.add('fade-in-up');
      if (logoSection) {
        logoSection.style.animationDelay = '0.2s';
        logoSection.classList.add('fade-in-up');
      }
      if (instructions) {
        instructions.style.animationDelay = '0.4s';
        instructions.classList.add('fade-in-up');
      }
      if (buttonSection) {
        buttonSection.style.animationDelay = '0.6s';
        buttonSection.classList.add('fade-in-up');
      }
      if (quickStats) {
        quickStats.style.animationDelay = '0.8s';
        quickStats.classList.add('fade-in-up');
      }
    });
  },
  methods: {
    async userLogin() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let result = await this.$http.post("login.php?crud=admin", {
            user_name: this.user_name,
            user_password: this.user_password
          });
          
          if (result.data.user_status) {
            let user = result.data;
            user.system_lock = false;
            sessionStorage.setItem("user", JSON.stringify(user));
            
            if (user.user_status == "A") {
              this.data_syslog.ApiKey = this.ApiKey;
              this.data_syslog.user_account = this.user_name;
              this.data_syslog.event_log = "login-admin";
              this.data_syslog.page_log = "loginAdmin";
              this.data_syslog.table_log = "";
              this.data_syslog.date_times = this.date_today_log;          

              await this.$http.post('data_syslog.insert.php', this.data_syslog);

              this.dialogLogin = false;
              this.dialog = true;
              this.dialog_msg = "เข้าสู่ระบบสำเร็จ - ผู้ดูแลระบบ";
              setTimeout(() => {
                this.$router.push("/admin");
              }, 1500);
            }       
            else if (user.user_status == "B") {
              sessionStorage.setItem("user", JSON.stringify(user));
              this.dialogLogin = false;
              this.dialog = true;
              this.dialog_msg = "เข้าสู่ระบบสำเร็จ - วิทยาลัย";
              setTimeout(() => {
                this.$router.push("/college");
              }, 1500);
            } 
            else if (user.user_status == "C"){
              this.dialogLogin = false;
              this.dialog = true;
              this.dialog_msg = "เข้าสู่ระบบสำเร็จ - Inventory";
              setTimeout(() => {
                this.$router.push("/iven");
              }, 1500);
            }   
            else if (user.user_status == "D") {
              this.dialogLogin = false;
              this.dialog = true;
              this.dialog_msg = "เข้าสู่ระบบสำเร็จ - บุคลากร";
              setTimeout(() => {
                this.$router.push("/personnel");
              }, 1500);
            }                   
            else if (user.user_status == "G"){
              sessionStorage.setItem("user", JSON.stringify(user));
              this.dialogLogin = false;
              this.dialog = true;
              this.dialog_msg = "เข้าสู่ระบบสำเร็จ - จังหวัด";
              setTimeout(() => {
                this.$router.push("/vecprovince");
              }, 1500);
            } 
            else if (user.user_status == "S"){
              sessionStorage.setItem("user", JSON.stringify(user));
              this.dialogLogin = false;
              this.dialog = true;
              this.dialog_msg = "เข้าสู่ระบบสำเร็จ - การนิเทศ";
              setTimeout(() => {
                this.$router.push("/supervisions");
              }, 1500);
            } 
            else {
              sessionStorage.clear();
              this.dialog = true;
              this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
            }
          } else {
            this.dialog = true;
            this.dialog_msg = "ชื่อผู้ใช้ หรือรหัสผ่าน ไม่ถูกต้อง";
          }
        } catch (error) {
          this.dialog = true;
          this.dialog_msg = "เกิดข้อผิดพลาดในการเข้าสู่ระบบ";
        } finally {
          this.loading = false;
        }
      }
    },   
  },
  computed: {
    color() {
      return "red lighten-1";
    },
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      today = dd + "/" + mm + "/" + yyyy + "/" + time;
      return today;
    },
  }
};
</script>

<style scoped>
.welcome-container {
  min-height: 80vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;
}

/* Floating Background Shapes */
.floating-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 80px;
  height: 80px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 120px;
  height: 120px;
  top: 70%;
  right: 10%;
  animation-delay: 2s;
}

.shape-3 {
  width: 60px;
  height: 60px;
  top: 30%;
  right: 30%;
  animation-delay: 4s;
}

.shape-4 {
  width: 100px;
  height: 100px;
  bottom: 10%;
  left: 20%;
  animation-delay: 1s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.main-content {
  position: relative;
  z-index: 1;
}

/* Welcome Card Styles */
.welcome-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.welcome-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, 
    rgba(102, 126, 234, 0.1) 0%, 
    rgba(118, 75, 162, 0.1) 100%);
  pointer-events: none;
}

.welcome-text-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  min-height: 350px;
  display: flex;
  align-items: center;
}

.welcome-badge {
  animation: fadeInUp 1s ease-out;
}

.glass-chip {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.welcome-title {
  font-size: 3rem;
  font-weight: 800;
  background: linear-gradient(45deg, #ffffff, #f0f0f0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.department-title {
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.3;
  animation: fadeInUp 1s ease-out 0.4s both;
}

.highlight-text {
  background: linear-gradient(45deg, #ffd700, #ffed4e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 700;
}

.feature-tags {
  animation: fadeInUp 1s ease-out 0.6s both;
}

.glass-chip-small {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  animation: slideInLeft 1s ease-out both;
}

/* Image Section */
.image-section {
  background: rgba(255, 255, 255, 0.02);
}

.image-container {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main-image {
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.1));
}

.floating-icon {
  position: absolute;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulse 2s infinite;
}

.icon-1 {
  top: 20%;
  right: 20%;
  animation-delay: 0s;
}

.icon-2 {
  bottom: 30%;
  left: 10%;
  animation-delay: 0.5s;
}

.icon-3 {
  top: 60%;
  right: 10%;
  animation-delay: 1s;
}

/* Login Card Styles */
.login-card {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.login-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.login-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logo-section {
  animation: bounceIn 1s ease-out;
}

.logo-background {
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
  position: relative;
  overflow: hidden;
}

.logo-background::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  animation: shimmer 3s linear infinite;
}

.logo-image {
  position: relative;
  z-index: 1;
}

.login-message {
  animation: fadeInUp 1s ease-out 0.3s both;
}

.login-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
}

.login-subtitle {
  color: #7f8c8d;
  margin: 0;
}

.login-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: 600;
  text-transform: none;
  font-size: 1.1rem;
  padding: 16px 32px;
  transition: all 0.3s ease;
  animation: fadeInUp 1s ease-out 0.5s both;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(102, 126, 234, 0.4);
}

/* Quick Stats */
.quick-stats {
  animation: fadeInUp 1s ease-out 0.7s both;
}

.stat-item {
  padding: 16px;
  border-radius: 12px;
  background: rgba(102, 126, 234, 0.05);
  transition: all 0.3s ease;
}

.stat-item:hover {
  background: rgba(102, 126, 234, 0.1);
  transform: translateY(-2px);
}

.stat-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
}

.stat-label {
  font-size: 0.85rem;
  color: #7f8c8d;
  margin-top: 4px;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .welcome-title {
    font-size: 2.2rem;
  }
  
  .department-title {
    font-size: 1.2rem;
  }
  
  .welcome-text-section {
    min-height: 250px;
  }
  
  .login-content {
    padding: 24px !important;
  }
  
  .logo-background {
    width: 100px;
    height: 100px;
  }
}

@media (max-width: 600px) {
  .welcome-title {
    font-size: 1.8rem;
  }
  
  .department-title {
    font-size: 1rem;
  }
  
  .main-content {
    margin: 0;
  }
  
  .pa-2 {
    padding: 8px !important;
  }
}
/* Main Container - Red Theme */
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 50%, #9b2c2c 100%);
  position: relative;
  overflow: hidden;
  padding: 20px 0;
}

.min-height-screen {
  min-height: 100vh;
}

/* Floating Background Shapes - Red Theme */
.floating-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  animation: float 6s ease-in-out infinite;
}

.shape-1 {
  width: 80px;
  height: 80px;
  top: 10%;
  left: 10%;
  animation-delay: 0s;
  background: rgba(255, 182, 193, 0.2);
}

.shape-2 {
  width: 120px;
  height: 120px;
  top: 70%;
  right: 10%;
  animation-delay: 2s;
  background: rgba(220, 20, 60, 0.15);
}

.shape-3 {
  width: 60px;
  height: 60px;
  top: 30%;
  right: 30%;
  animation-delay: 4s;
  background: rgba(255, 99, 132, 0.2);
}

.shape-4 {
  width: 100px;
  height: 100px;
  bottom: 10%;
  left: 20%;
  animation-delay: 1s;
  background: rgba(178, 34, 34, 0.18);
}

@keyframes float {
  0%, 100% { 
    transform: translateY(0px) rotate(0deg); 
  }
  50% { 
    transform: translateY(-20px) rotate(180deg); 
  }
}

/* Main Content */
.main-content {
  position: relative;
  z-index: 1;
}

/* Login Card */
.login-main-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  overflow: hidden;
}

.login-main-card:hover {
  transform: translateY(-5px);
}

/* Header Section - Red Theme */
.login-header-section {
  background: linear-gradient(135deg, rgba(229, 62, 62, 0.08) 0%, rgba(197, 48, 48, 0.08) 100%);
  padding: 40px 20px 20px;
}

/* Logo Section - Red Theme */
.logo-background {
  width: 120px;
  height: 120px;
  background: linear-gradient(135deg, #e53e3e, #c53030);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 15px 35px rgba(229, 62, 62, 0.4);
  position: relative;
  overflow: hidden;
}

.logo-background::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  animation: shimmer 3s linear infinite;
}

.logo-image {
  position: relative;
  z-index: 1;
}

/* Text Styles */
.login-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 8px;
}

.login-subtitle {
  color: #4a5568;
  font-size: 1.1rem;
}

/* Chips - Red Theme */
.glass-chip {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  background: linear-gradient(135deg, rgba(229, 62, 62, 0.9), rgba(197, 48, 48, 0.9)) !important;
}

.glass-chip-example {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 152, 0, 0.5) !important;
  background: rgba(255, 152, 0, 0.1) !important;
}

/* Login Button - Red Theme */
.login-btn {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 50%, #9b2c2c 100%) !important;
  color: white !important;
  font-weight: 600;
  text-transform: none;
  font-size: 1.2rem;
  padding: 20px 40px;
  transition: all 0.3s ease;
  border: none !important;
  min-height: 60px;
}

.login-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 20px 40px rgba(229, 62, 62, 0.5) !important;
}

/* Dialog Styles - Red Theme */
.login-dialog {
  background: rgba(255, 255, 255, 0.98) !important;
  backdrop-filter: blur(20px);
  overflow: hidden;
}

.dialog-header {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 50%, #9b2c2c 100%) !important;
}

.dialog-title-content {
  display: flex;
  align-items: center;
  width: 100%;
}

.dialog-icon-bg {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dialog-header h3 {
  font-size: 1.5rem;
  font-weight: 600;
}

.dialog-header .subtitle {
  font-size: 0.9rem;
  opacity: 0.9;
}

/* Form Styles */
.enhanced-input .v-input__control {
  transition: all 0.3s ease;
}

.enhanced-input:hover .v-input__control {
  transform: translateY(-1px);
}

/* Button Styles - Red Theme */
.submit-btn {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%) !important;
  color: white !important;
  font-weight: 600;
  text-transform: none;
}

.cancel-btn {
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: rgba(0, 0, 0, 0.05) !important;
}

/* Quick Stats - Red Theme */
.stat-item {
  transition: all 0.3s ease;
  background: rgba(229, 62, 62, 0.05) !important;
  border: 1px solid rgba(229, 62, 62, 0.1);
}

.stat-item:hover {
  background: rgba(229, 62, 62, 0.1) !important;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(229, 62, 62, 0.2);
}

.stat-number {
  font-size: 1.3rem;
  font-weight: 700;
  color: #c53030;
}

.stat-label {
  font-size: 0.9rem;
  color: #4a5568;
}

/* Enhanced Snackbar - Red Theme */
.enhanced-snackbar .v-snack__wrapper {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%) !important;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

.fade-in-up {
  animation: fadeInUp 1s ease-out both;
}

/* Responsive Design */
@media (max-width: 960px) {
  .login-title {
    font-size: 1.8rem;
  }
  
  .login-subtitle {
    font-size: 1rem;
  }
  
  .logo-background {
    width: 100px;
    height: 100px;
  }
  
  .login-btn {
    font-size: 1.1rem;
    padding: 16px 32px;
  }
  
  .login-header-section {
    padding: 30px 15px 15px;
  }
}

@media (max-width: 600px) {
  .login-title {
    font-size: 1.6rem;
  }
  
  .logo-background {
    width: 90px;
    height: 90px;
  }
  
  .glass-chip {
    font-size: 0.8rem;
    margin: 2px !important;
  }
  
  .login-header-section {
    padding: 20px 10px 10px;
  }
  
  .login-btn {
    font-size: 1rem;
    min-height: 50px;
  }
}
</style>